import React, { useEffect, useState, useRef } from "react";
import { notificationsService } from "../notifications/notificationsService";
import { useAuth } from "../context/AuthContext";
import { Card, CardContent, Typography, List, ListItem, ListItemText, Badge, Button, IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";

const POLL_INTERVAL = 10000; // 10 seconds

const AgentNotificationsWidget = () => {
    const { currentUser } = useAuth();
    const { t } = useTranslation();
    const [notifications, setNotifications] = useState([]);
    const intervalRef = useRef();

    const fetchNotifications = () => {
        if (currentUser) {
            notificationsService.getNotificationsForUser(currentUser.uid, { limitCount: 5 }).then(setNotifications);
        }
    };

    useEffect(() => {
        fetchNotifications();
        intervalRef.current = setInterval(fetchNotifications, POLL_INTERVAL);
        return () => clearInterval(intervalRef.current);
    // eslint-disable-next-line
  }, [currentUser]);

    const handleMarkAsRead = async (notifId) => {
        await notificationsService.markAsRead(notifId);
        fetchNotifications();
    };

    return (
        <Card sx={{ mb: 2 }}>
            <CardContent>
                <Typography variant="h6">{t("dashboard.notifications", "Recent Notifications")}</Typography>
                <List>
                    {notifications.length === 0 ? (
                        <ListItem>
                            <ListItemText primary={t("dashboard.noNotifications", "No notifications yet.")} />
                        </ListItem>
                    ) : (
                        notifications.map(n => (
                            <ListItem key={n.id} sx={{ opacity: n.read ? 0.6 : 1 }}
                                secondaryAction={
                                    !n.read && (
                                        <Tooltip title={t("dashboard.markAsRead", "Mark as read")}>
                                            <IconButton edge="end" onClick={() => handleMarkAsRead(n.id)}>
                                                <MarkEmailReadIcon />
                                            </IconButton>
                                        </Tooltip>
                                    )
                                }
                            >
                                <ListItemText
                                    primary={n.message}
                                    secondary={new Date(n.date).toLocaleString()}
                                />
                                {!n.read && <Badge color="primary" variant="dot" />}
                            </ListItem>
                        ))
                    )}
                </List>
                <Button href="/notifications" size="small">{t("dashboard.viewAll", "View All")}</Button>
            </CardContent>
        </Card>
    );
};

export default AgentNotificationsWidget; 